export function queryCancelSubscription (vars) {
    return {
      query: `mutation ($i: CancelSubscriptionInput) {
            cancelSubscription (
                cancelSubscriptionInput: $i
            )
            {
                edges {
                    node {
                        subscriptionId
                        customerId
                    }
                    cursor
                }
                pageInfo {
                    endCursor
                    hasNextPage
                }
                totalCount
            }
        }`,
      variables: vars,
    };
}
